var chunkToChildrenMap = {
	"53087": [
		49232,
		25247,
		47976,
		44887,
		62678,
		66707,
		19963,
		93495,
		59037,
		95202,
		56793,
		83045,
		91982,
		54751,
		26237,
		83974,
		88379,
		6754,
		21222,
		16390,
		2096,
		765,
		43981,
		13902,
		39387,
		89845,
		95605,
		53209,
		89741
	],
	"89741": [
		25247,
		47976,
		44887,
		66707,
		93495,
		43745,
		95202,
		83045,
		54751,
		26237,
		39308,
		77907,
		48685
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));